import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { callGetApiWithoutAuth, callPostApi } from "../api/ApiCaller";
import {
    PLAYER_CREATE_ACCOUNT_POST,
    PLAYER_GUEST_CITY_LIST_GET,
    PLAYER_GUEST_COUNTRY_LIST_GET,
    PLAYER_GUEST_STATE_LIST_GET,
} from "../api/ApiConst";
import { STATUS } from "../utils/Constants";
import toast from "react-hot-toast";
import dateUtilities from "../utils/DateUtilities";
import Select from "react-select";
import EditAddressModal from "./EditAddressModal";

const RegisterScreen = () => {
    const defaultObj = {
        userName: "",
        password: "",
        confirmPassword: "",
        email: "",
        cpf: "",
        gender: "",
        nationality: "",
        contact: "",
        country: "",
        city: "",
        street: "",
        state: "",
        neighborhood: "",
        number: "",
        cep: "",
        complement: "",
        marketingConsent: true
    };

    const navigate = useNavigate();
    const [registerAccount, setRegisterAccount] = useState(defaultObj);
    const [open, setOpen] = useState(false);
    const [ageAgree, setAgeAgree] = useState(false);
    const handleInputChange = (e) => {
        const { name, value, type, checked } = e.target;
        setRegisterAccount(prev => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value
        }));
    }

    const validation = () => {
        if (!registerAccount.cpf.trim()) {
            toast.error('Enter CPF.');
            return true;
        } else if (!registerAccount?.nationality.trim()) {
            toast.error('Select nationality.');
            return true;
        } else if (!registerAccount?.gender.trim()) {
            toast.error('Select gender.');
            return true;
        } else if (!registerAccount?.email.trim()) {
            toast.error('Enter email.');
            return true;
        } else if (!registerAccount?.contact.trim()) {
            toast.error('Enter contact.');
            return true;
        } else if (!registerAccount?.userName.trim()) {
            toast.error('Enter name.');
            return true;
        } else if (!registerAccount?.password.trim()) {
            toast.error('Enter password.');
            return true;
        } else if (!registerAccount?.confirmPassword.trim()) {
            toast.error('Enter confirm password.');
            return true;
        } else if (registerAccount?.password !== registerAccount.confirmPassword) {
            toast.error('Password mismatch.');
            return true;
        } else if (!registerAccount?.country.trim()) {
            toast.error('Select country.');
            return true;
        } else if (!ageAgree) {
            toast.error('Give your age consent.');
            return true;
        } else if (!registerAccount?.cep.trim()) {
            toast.error('Enter ZIP code.');
            return true;
        } else if (!registerAccount?.street.trim()) {
            toast.error('Enter street.');
            return true;
        } else if (!registerAccount?.number.trim()) {
            toast.error('Enter number.');
            return true;
        } else if (!registerAccount?.complement.trim()) {
            toast.error('Enter complement.');
            return true;
        } else if (!registerAccount?.neighborhood.trim()) {
            toast.error('Enter neighborhood.');
            return true;
        } else if (!registerAccount?.state.trim()) {
            toast.error('Select state.');
            return true;
        } else if (!registerAccount?.city.trim()) {
            toast.error('Enter city.');
            return true;
        }
        return false;
    }

    const handleRegisterAccount = (e) => {
        e.preventDefault();
        if (validation()) {
            return;
        }
        const payload = { ...registerAccount };
        delete payload.confirmPassword;

        callPostApi(
            PLAYER_CREATE_ACCOUNT_POST,
            payload,
            {},
            (response) => {
                if (response.errorCode === STATUS.SUCCESS) {
                    setRegisterAccount(defaultObj);
                    toast.success(response.message, { id: "Toast" });
                    navigate("/");
                } else {
                    toast.error(response.message);
                }
            },
            (e) => {
                console.error(e);
            }
        );
    };

    const handleTextChange = (e) => {
        const { name, value } = e.target;
        setRegisterAccount((prev) => ({ ...prev, [name]: value }));
    };
    console.log(registerAccount)
    return (
        <div className="main-content">
            <div className="container-fluid">
                <div className="row justify-content-center login-content">
                    <div className="col-xl-4 col-md-8 col-9 text-center">
                        <img
                            src="assets/img/logo.png"
                            alt="logo"
                            className="img-fluid lw-sm"
                        />
                        <form onSubmit={handleRegisterAccount}>
                            <div className="lb-box re-content mt-3 px-0">
                                <div className="px-3" style={{ maxHeight: "450px", overflow: "auto" }}>
                                    <h6 className="text-white h5 mb-3 mt-0">Create Account</h6>
                                    <div className="form-control mb-3">
                                        <h6 className="m-0 me-2 text-start fs-6 fw-light text-black ">
                                            CPF
                                        </h6>
                                        <div className="input-group">
                                            <input
                                                type="number"
                                                aria-label="CPF"
                                                aria-describedby="CPF"
                                                name="cpf"
                                                id="cpf"
                                                value={registerAccount.cpf}
                                                onChange={handleTextChange}
                                            />
                                        </div>
                                    </div>
                                    <div className="d-flex gap-2 mb-3">
                                        <div className="form-group text-start form-control">
                                            <h6 className="m-0 me-2 text-start fs-6 fw-light text-black ">
                                                Nationality
                                            </h6>
                                            <select
                                                id="nationality"
                                                name="nationality"
                                                value={registerAccount.nationality || ''}
                                                onChange={handleInputChange}
                                                required
                                                style={{
                                                    padding: '0',
                                                    width: "100%"
                                                }}
                                            >
                                                <option value="">Select Nationality</option>
                                                <option value="Brasil">Brazil</option>
                                                <option value="Argentina">Argentina</option>
                                                <option value="Chile">Chile</option>
                                                <option value="Colombia">Colombia</option>
                                                <option value="Mexico">Mexico</option>
                                                <option value="Peru">Peru</option>
                                                <option value="Uruguay">Uruguay</option>
                                                <option value="Venezuela">Venezuela</option>
                                            </select>
                                        </div>
                                        <div className="form-group text-start form-control">
                                            <h6 className="m-0 me-2 text-start fs-6 fw-light text-black ">
                                                Gender
                                            </h6>
                                            <select
                                                id="gender"
                                                name="gender"
                                                value={registerAccount.gender || ''}
                                                onChange={handleInputChange}
                                                required
                                                style={{
                                                    padding: '0',
                                                    width: "100%"
                                                }}
                                            >
                                                <option value="">Select Gender</option>
                                                <option value="MALE">Male</option>
                                                <option value="FEMALE">Female</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div className="form-control mb-3">
                                        <h6 className="m-0 text-black me-2 text-start fs-6 fw-light ">
                                            E-mail:
                                        </h6>
                                        <div className="input-group ">
                                            <input
                                                type="text"
                                                aria-label="Email"
                                                aria-describedby="Email"
                                                name="email"
                                                value={registerAccount.email}
                                                onChange={handleTextChange}
                                            />
                                        </div>
                                    </div>
                                    <div className="form-control mb-3">
                                        <h6 className="m-0 text-black me-2 text-start fs-6 fw-light ">
                                            Contact:
                                        </h6>
                                        <div className="input-group ">
                                            <input
                                                type="text"
                                                aria-label="Contact"
                                                aria-describedby="Contact"
                                                name="contact"
                                                value={registerAccount.contact}
                                                onChange={handleTextChange}
                                            />
                                        </div>
                                    </div>
                                    <div className="form-control mb-3">
                                        <h6 className="m-0 text-black me-2 text-start fs-6 fw-light ">
                                            Name:
                                        </h6>
                                        <div className="input-group">
                                            <input
                                                type="text"
                                                aria-label="Username"
                                                aria-describedby="Username"
                                                name="userName"
                                                value={registerAccount.userName}
                                                onChange={handleTextChange}
                                            />
                                        </div>
                                    </div>
                                    <div className=" d-flex gap-2">
                                        <div className="form-control mb-3 w-100">
                                            <h6 className="m-0 text-black text-start fs-6 fw-light ">
                                                Password
                                            </h6>
                                            <div className="input-group ">
                                                <input
                                                    className="w-100"
                                                    type="text"
                                                    aria-label="Password"
                                                    aria-describedby="Password"
                                                    name="password"
                                                    value={registerAccount.password}
                                                    onChange={handleTextChange}
                                                />
                                            </div>
                                        </div>
                                        <div className="form-control mb-3 w-100">
                                            <h6 className="m-0 text-black text-start fs-6 fw-light ">
                                                Confirm password
                                            </h6>
                                            <div className="input-group ">
                                                <input
                                                    className="w-100"
                                                    type="text"
                                                    name="confirmPassword"
                                                    value={registerAccount.confirmPassword}
                                                    onChange={handleTextChange}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="d-flex flex-column w-100">
                                        <div className="form-control justify-content-between d-flex mb-3">
                                            <span>Sem endereço no momento.</span>
                                            <button
                                                type="button"
                                                onClick={() => setOpen(true)}
                                                style={{
                                                    background: "#000",
                                                    color: "#fff",
                                                    border: "none",
                                                    padding: "6px 10px",
                                                    borderRadius: 6,
                                                    cursor: "pointer",
                                                    fontSize: 13,
                                                }}
                                            >
                                                Adicionar um endereço
                                            </button>
                                            {open && <EditAddressModal
                                                open={open}
                                                onClose={() => setOpen(false)}
                                                registerAccount={registerAccount}
                                                onSave={(data) => {
                                                    // placeholder save action
                                                    setRegisterAccount((prev) => ({
                                                        ...prev,
                                                        ...data
                                                    }));
                                                    setOpen(false);
                                                }}
                                            />}
                                        </div>

                                        <label className="form-control d-flex gap-2 mb-3">
                                            <input
                                                type="checkbox"
                                                name="ageAgree"
                                                checked={!!ageAgree}
                                                onChange={(e) => setAgeAgree(e.target.checked)}
                                                style={{ width: 18, height: 18, marginTop: 2 }}
                                            />
                                            <div style={{ fontSize: 14, lineHeight: 1.3, textAlign: "left" }}>
                                                Confirmo que tenho mais de 18 anos e aceito{" "}
                                                <a
                                                    href="#"
                                                    style={{ color: "#9ad4ff", textDecoration: "underline" }}
                                                    onClick={(e) => e.preventDefault()}
                                                >
                                                    Termos de uso
                                                </a>{" "}
                                                e{" "}
                                                <a
                                                    href="#"
                                                    style={{ color: "#9ad4ff", textDecoration: "underline" }}
                                                    onClick={(e) => e.preventDefault()}
                                                >
                                                    Política de Privacidade
                                                </a>
                                                .
                                            </div>
                                        </label>

                                        <label className="form-control d-flex gap-2"
                                        >
                                            <input
                                                type="checkbox"
                                                name="marketingConsent"
                                                checked={registerAccount.marketingConsent ?? true}
                                                onChange={handleInputChange}
                                                style={{ width: 18, height: 18, marginTop: 2 }}
                                            />
                                            <div style={{ fontSize: 14, lineHeight: 1.3, textAlign: "left" }}>
                                                Autorizo que Playbonds me envie novidades e promoções por email, SMS ou
                                                WhatsApp.
                                            </div>
                                        </label>
                                    </div>
                                </div>
                                {/* <div className="mt-lg-3 mt-md-3 mt-2 dob-select">
                                    <h6 className="m-0 text-white me-2 text-start fs-6 fw-light ">
                                        Date of Birth:
                                    </h6>
                                    <div className="d-flex align-items-center justify-content-between">
                                        <select
                                            value={day}
                                            onChange={(e) => setDay(e.target.value)}
                                        >
                                            <option value="">Day</option>
                                            {days.map((d) => (
                                                <option key={d} value={d}>
                                                    {d}
                                                </option>
                                            ))}
                                        </select>
                                        <select
                                            value={month}
                                            onChange={(e) => setMonth(e.target.value)}
                                        >
                                            <option value="">Month</option>
                                            {months.map((m) => (
                                                <option key={m.value} value={m.value}>
                                                    {m.label}
                                                </option>
                                            ))}
                                        </select>
                                        <select
                                            value={year}
                                            onChange={(e) => setYear(e.target.value)}
                                        >
                                            <option value="">Year</option>
                                            {years.map((y) => (
                                                <option key={y} value={y}>
                                                    {y}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                </div> */}
                                {/* <h6 className="m-0 text-white me-2 text-start fs-6 fw-light ">
                                    Country:
                                </h6>
                                <div className="d-flex align-items-center justify-content-between">
                                    <Select
                                        value={selectedCountry}
                                        options={countryList}
                                        onChange={handleCountryChange}
                                        placeholder="Select Country"
                                    />
                                    <Select
                                        value={selectedState}
                                        options={stateList}
                                        onChange={handleStateChange}
                                        placeholder="Select State"
                                        isDisabled={!selectedCountry}
                                    />
                                    <Select
                                        value={selectedCity}
                                        options={cityList}
                                        onChange={handleCityChange}
                                        placeholder="Select City"
                                        isDisabled={!selectedState}
                                    />
                                </div> */}
                                <div className="px-3">
                                    <button
                                        type="submit"
                                        className="w-100 cursor-pointer btn-outer border-0 mt-lg-4 mt-md-3 mt-3 mb-lg-2 mb-md-2 mb-1"
                                    >
                                        <span className="btn-inner">Register</span>
                                    </button>
                                    <button
                                        className="w-100 cursor-pointer btn-outer border-0 mt-3 mb-lg-2 mb-md-2 mb-1"
                                        onClick={() => navigate("/login")}
                                    >
                                        <span className="btn-inner bg-blue">Login</span>
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div >
        </div >


    );
};

export default RegisterScreen;
